<template>
  <v-layout justify-center class="white">
    <v-flex xs12 sm10 md10 justify-center>
      <v-layout>
        <v-flex xm12 sm4 class="title text-xs-center text-sm-left align-center">
        </v-flex>
        <v-flex xm12 md4 class="text-sm-center">
          <span class="headline">Notes</span><br />
        </v-flex>
      </v-layout>

      <v-card>
        <v-card-text>
          <vue-good-table
            ref="my-table"
            styleClass="vgt-table striped bordered"
            :max-height=this.height
            :fixed-header="true"
            :isLoading=this.isTableLoading
            :columns="columns"
            :rows="rows"
            :search-options="{
              enabled: true
            }">
            <template slot="loadingContent">
              <div>
                <v-progress-circular
                  :size="50"
                  :width="7"
                  color="blue"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
            <div slot="table-actions-bottom">
              <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
            </div>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'actions'">
                <div class="text-xs-center">
                  <v-avatar
                    color="blue lighten-4"
                    class="mr-2 mt-2"
                    size="30"
                    style="cursor: pointer;"
                    @click="changeItem(props)"
                  >
                    <v-icon small>edit</v-icon>
                  </v-avatar>
                </div>
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
          </vue-good-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="newItem">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit Note</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
            <v-btn dark flat @click="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-textarea
                  v-model="editItem.note"
                  label="Notes"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import moment from 'moment'

export default {
  props: ['item'],

  components: {
    VueGoodTable
  },

  data () {
    return {
      myId: this.$store.state.user.id,
      myName: this.$store.state.user.fullName,
      page: 'list',
      currentYear: 0,
      dialog: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      toggle_multiple: ['chair', 'assist', 'excel'],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      height: 0,
      columns: [
        {
          label: 'Note',
          field: 'note',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Date',
          field: 'date',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Who',
          field: 'who',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Action',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: false,
          html: true,
          width: '60px'
        }
      ],
      committeeHeader: {},
      rows: [],
      editItem: {},
      evalItem: {},
      liason: {},
      showEmailForm: false,
      showEvalForm: false,
      emails: [],
      cc: [],
      bcc: [],
      emailList: [],
      ccList: [],
      bccList: [],
      emailText: '',
      memberList: [],
      memberTitles: ['Chair', 'Assist Chair', 'Primary', 'Secondary']
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getNotes()
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  methods: {
    handleResize () {
      const height = window.innerHeight - 600
      this.height = height + 'px'
    },

    newItem () {
      this.editItem = {}
      this.dialog = true
    },

    changeItem (props) {
      this.editItem = props.row
      this.dialog = true
    },

    async save () {
      try {
        this.editItem.UserId = this.myId
        this.editItem.VendorCompanyId = this.item.id

        const response = await Api().post('vendor_notes', this.editItem)
        let note = response.data.note

        let dDate = moment(note.createdAt).format('MM/DD/YYYY - hh:mm A')
        note.date = dDate
        note.who = this.myName
        this.rows.push(note)

        const sorted = this.rows.sort((firstItem, secondItem) => firstItem.createdAt + secondItem.createdAt)

        this.rows = sorted
        this.close()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getNotes () {
      try {
        const response = await Api().get('vendor_notes/' + this.item.id)
        const history = response.data

        for (let i in history) {
          let item = {}
          let dDate = moment(history[i].createdAt).format('MM/DD/YYYY - hh:mm A')
          item.note = history[i].note
          item.who = history[i].User.fullName
          item.date = dDate
          item.createdAt = history[i].createdAt
          this.rows.push(item)
        }

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    close () {
      this.editItem = {}
      this.dialog = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/vendor/NotesList.vue